import { render, staticRenderFns } from "./DocumentosPenalidadesAta.vue?vue&type=template&id=32035ae4&scoped=true"
import script from "./DocumentosPenalidadesAta.vue?vue&type=script&lang=js"
export * from "./DocumentosPenalidadesAta.vue?vue&type=script&lang=js"
import style0 from "./DocumentosPenalidadesAta.vue?vue&type=style&index=0&id=32035ae4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32035ae4",
  null
  
)

export default component.exports